import { Trade } from "emrn-hybrid/Trade";

const KEY_CURRENT = "emrnweb.trade.account.current";
const KEY_HISTORY = "emrnweb.trade.account.history";

export const TradeAccountStore = {
  getCurrent: function () {
    const cache = localStorage.getItem(KEY_CURRENT);
    const response = parse<Trade.GetAccountInfoResponse>(cache);
    return response || { hasLogin: false, info: undefined };
  },

  setCurrent: function (current: Trade.GetAccountInfoResponse) {
    const { info } = current;
    if (info && info.userId) {
      const history = TradeAccountStore.getHistory();
      if (!Array.isArray(history.historyTradeUsers)) {
        history.historyTradeUsers = [];
      }
      const matched = history.historyTradeUsers.find(
        (h) => h.userId == info.userId
      );
      if (matched) {
        Object.assign(matched, info);
      } else {
        history.historyTradeUsers.push(info);
      }
      localStorage.setItem(KEY_HISTORY, JSON.stringify(history));
    }
    localStorage.setItem(KEY_CURRENT, JSON.stringify(current));
  },

  getHistory: function () {
    const cache = localStorage.getItem(KEY_HISTORY);
    const response = parse<Trade.GetHistoryTradeAccountInfosResponse>(cache);
    return response || { historyTradeUsers: [] };
  },

  removeHistory: function (userId: string) {
    const history = TradeAccountStore.getHistory();
    if (history && Array.isArray(history.historyTradeUsers)) {
      history.historyTradeUsers = history.historyTradeUsers.filter(
        (h) => h.decryptUserId != userId
      );
    }
    localStorage.setItem(KEY_HISTORY, JSON.stringify(history));
  },
};

function parse<T>(cache: string | null) {
  if (cache) {
    try {
      const response = JSON.parse(cache);
      if (response && typeof response == "object") {
        return response as T;
      }
    } catch (error) {}
  }
  return undefined;
}
